let windowOverride: Window | null;

/**
 * Functions for getting and overriding global window variable.
 */

/**
 * Call this function to get global window object.
 *
 * @return Returns current window.
 */
export const getWindow = (): Window => {
   if (windowOverride) {
      return windowOverride;
   }

   return window;
};

/**
 * Call this function to override current window variable.
 *
 * @param {Window} window
 */
export const overrideWindow = (window: Window | null): void => {
   windowOverride = window;
};
